module.exports = __webpack_public_path__ + "static/Logo_3-870fc10d1ab9483891e4731909e11b35.png";